import { CompanyDetailsComponent } from './../../../tech-buyer/company-details/company-details.component';
import { Component, OnInit, Inject, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { FilterUtilService } from "@app/shared/services/filter-util.service";
import { SortValues } from "@app/shared/constants/app.constants";
import { DOCUMENT } from "@angular/common";
import { Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";
import swal from "sweetalert2";
import { DataService } from "@app/feature/main/roles-shared/services/data.service";
import { Paginator } from "primeng/paginator";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { ShareButtons } from '@ngx-share/core';
import * as _ from 'lodash';
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { LikeModalServiceService } from '@app/shared/services/like-modal-service.service';
import { Subscription } from "rxjs/Subscription";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { Observable } from 'rxjs/Observable';
import { debounceTime , distinctUntilChanged, switchMap, map} from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { LoaderService } from '@app/shared/services/loader.service';
import { GlobalDataSharedService } from '../../services/global-data-shared-service.service';


declare var $: any;
@Component({
  selector: "app-all-research",
  templateUrl: "./all-research.component.html",
  styleUrls: ["./all-research.component.css"],
})
export class AllResearchComponent implements OnInit, OnDestroy {
  @ViewChild('paginatorId') paginator = new Paginator();
  @ViewChild(CompanyDetailsComponent) companyDetails: CompanyDetailsComponent;
  @ViewChild('searchInput') searchInput : ElementRef;
  @ViewChild('filterInput') filterInput : ElementRef;

  allResearchData = [];
  userDetailsObject;
  public now: Date = new Date();
  leftMenuExpand = false;
  filterObj: object;
  sortListData;
  selectedSortOrder = {};
  techDomainListData: object;
  userRole;
  loggedInStatus;
  userId = "";
  hasCompanyDetails = false;
  techDomainListselected = null;

  // search
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  sortSelectedindex = null;
  techDomainData;

  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;
  filterKeyId: string;
  noResearchData: boolean;
  shareUrl: string;
  subscription: Subscription;
  isActiveID: string;
  noDataCheck: boolean = false;
  paramObj;
  lastSearch = {};
  user_info: any;
  parsedData: any;
  org_id: any;
  role_name: any;
  constructor(
    public rolesSharedService: RolesSharedService,
    public filterUtilService: FilterUtilService,
    private router: Router,
    private breadcrumService:BreadcrumService,
    private authenticationService: AuthenticationService,
    private techBuyerService: TechBuyerService,
    @Inject(DOCUMENT) private document: Document,
    private dataService: DataService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    public activatedRoute: ActivatedRoute,
    public share: ShareButtons,
    private likeModalService: LikeModalServiceService,
    private techDomainService: TechDomainService,
    private loaderService: LoaderService,
    private globalDataSharedService: GlobalDataSharedService
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);

  }

  ngOnInit() {
    const tempSession = sessionStorage.getItem('userDetails');
    localStorage.setItem('tempSession',tempSession);
    this.isLoggedIn();
    this.userDetails();
    this.getDomainList();
    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;

    this.getAllResearchData();
    this.getTechBuyerDetails();
    this.sortListData = SortValues.list;

    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.isLoggedIn();
        if (this.loggedInStatus) {
          this.techDomainListselected = newSelectedIds;
          this.applyFilter();
        }
    });
    this.globalDataSharedService.getreceivedExpandedFlag().subscribe((param: boolean) => {
      //   console.log('leftMenuExpand param:', param);
      this.leftMenuExpand = param;
    });
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      // ,filter(res => res.length > 2)
      // Time in milliseconds between key events
      ,debounceTime(1000)        
      // If previous query is diffent from current   
      ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchString = text;
        this.dataLimit = 9;
        this.skipValue = 0;
        if (this.paginator) {
          this.paginator.first = 0;
        }
        this.allResearchData = [];
        this.getAllResearchData()
      });
      fromEvent(this.filterInput.nativeElement, 'change').pipe(
        // get value
        map((event: any) => {
          return this.techDomainListselected;
          // return event.target.value;
        })
        // if character length greater then 2
        // ,filter(res => res.length > 2)
        // Time in milliseconds between key events
        ,debounceTime(1000)        
        // If previous query is diffent from current   
        ,distinctUntilChanged()
        // subscription for response
        ).subscribe((text: string) => {
          this.filterKeyId = text;
          // this.allResearchData = [];
          this.applyFilter();
        });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }


  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
    this.checkDetails();
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {

      this.techDomainListData = data;
    });
  }

  allResearchDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        { survey: { responses: "users" } },
        "domain",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" },
        { bookmark: "user" }
      ]
    });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex ? JSON.stringify(this.sortSelectedindex) : JSON.stringify({ "ranking": "DESC" });
    if (this.techDomainListselected) {
      filter.where = JSON.stringify({
        techDomainId: this.techDomainListselected
      });
    }

    return filter;
  }

  applyFilter() {
    this.dataLimit = 9;
    this.skipValue = 0;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.allResearchData = [];
    this.getAllResearchData();
  }
  onScrollDown() {
    if(this.allResearchData.length>0){
    this.skipValue = this.skipValue + 9;
    }
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.skipValue < this.totalRecords) {
      this.getAllResearchData();
    }
  }
  // getAllResearchData() {
  //   this.noDataCheck = false;
  //   if (this.subscription) {
  //     this.subscription.unsubscribe();
  //   }
  //  this.subscription = this.rolesSharedService
  //     .getAllResearches(this.allResearchDataFilter())
  //     .subscribe(
  //       (response: any) => {
  //         this.loaderService.display(false);

  //         if (response['totalCount'] == 0) {
  //           this.noResearchData = true;
  //         } else {
  //           this.noResearchData = false;
  //         }

  //         let allResearchDat: any = [];
  //         allResearchDat = response.data;
  //         this.allResearchData = _.uniqWith([...this.allResearchData, ...allResearchDat.filter(data => data.isActive)], _.isEqual);
  //         if(this.allResearchData.length === 0) {
  //           this.noDataCheck = true
  //         }
  //         else {
  //           this.noDataCheck = false;
  //         }
  //         this.totalRecords = response.totalCount;
  //       },
  //       error => {
  //       }
  //     );
  //     return this.searchKeyword;
  // }
  getAllResearchData() {
    this.noDataCheck = false;
    let searchKey = this.searchString;
    let filterKey = this.filterKeyId;
    this.rolesSharedService
      .getAllResearches(this.allResearchDataFilter())
      .subscribe(
        (response: any) => {
          if ((searchKey === this.searchString) && (filterKey === this.filterKeyId)) {
            this.loaderService.display(false);
            if (response['totalCount'] == 0) {
              this.noResearchData = true;
            } else {
              this.noResearchData = false;
            }
            let allResearchDat: any = [];
            if(this.loggedInStatus === true) {
              this.user_info = window.localStorage.getItem('tempSession');
              this.parsedData = JSON.parse(this.user_info);
              this.org_id = this.parsedData['organizationId'];
              this.role_name=this.parsedData['roles'][0]['name'];
              }
             response.data.forEach( (item, index) => {
                   if (item.organizationId && item.organizationId !== this.org_id && this.role_name!== 'Ecosystm Staff') {
                   response.data.splice(index, 1);
                  }
                 });
            allResearchDat = response.data;
            this.allResearchData = _.uniqWith([...this.allResearchData, ...allResearchDat.filter(data => data.isActive)], _.isEqual);
            if(this.allResearchData.length === 0) {
              this.noDataCheck = true;
            }
            else {
              this.noDataCheck = false;
            }
            this.totalRecords = response.totalCount;
          }
        },
        error => {
        }
      );
      return this.searchKeyword;
  }
  isAccessible(allResearchDat) {
    // research document click
    if (this.loggedInStatus && this.userRole === "tech-buyer") {
      this.router.navigate([`${this.userRole}/research-snapshot/${allResearchDat.id}`]);
    } else if (this.loggedInStatus && (this.userRole === "tech-vendor" || this.userRole === "tech-analyst"  || this.userRole === "ecosystm-staff")) {
      this.snapshotPageNavigation(allResearchDat);
    } else if (!this.loggedInStatus) {
      // fix reditect login
      localStorage.removeItem("REDIRECT_URL");
      localStorage.removeItem("RESEARCH_URL");
      localStorage.removeItem("RESEARCH_BUYER_URL");
      localStorage.removeItem("RESEARCH_ANALYST_URL");
      localStorage.removeItem("RESEARCH_STAFF_URL");

      localStorage.setItem('RESEARCH_URL', `/market-data/${allResearchDat.id}`);
      localStorage.setItem('RESEARCH_BUYER_URL', `/${allResearchDat.id}`);
      localStorage.setItem('RESEARCH_ANALYST_URL', `/${allResearchDat.id}`);
      localStorage.setItem('RESEARCH_STAFF_URL', `/${allResearchDat.id}`);
      
      this.router.navigate([`/signin`]);
    }
  }

  refresh(evt: any) {
    // company details event
    // this.getTechBuyerDetails();
    // $("#company-details").modal("hide");
  }

  getTechBuyerDetails() {
    this.techBuyerService
      .getTechBuyerDetails(this.userId)
      .subscribe((response: any) => {
        if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
          const modifiedUserDetails = Object.assign(
            JSON.parse(window.sessionStorage.getItem("userDetails")),
            { organization: response.organization },
            { techBuyerOrganization: response.techbuyerOrganization }
          );
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(modifiedUserDetails)
          );
          if (window.localStorage.getItem("rememberMeStatus")) {
            if (window.localStorage.getItem("rememberMeStatus") === "true") {
  
              window.localStorage.setItem(
                "userDetails",
                JSON.stringify(modifiedUserDetails)
              );
            }
        }
        }
        this.checkDetails();
      });
  }

  checkDetails() {
    const userDetails = JSON.parse(window.sessionStorage.getItem("userDetails"));
    if ( userDetails && userDetails.organization) {
      this.hasCompanyDetails = true;
    } else {
      this.hasCompanyDetails = false;
    }
  }


  likeClick(postData: any) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        const likeObject = {
          postId: postData.id,
          postType: "research_document",
          userId: this.userId
        };
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            this.rolesSharedService.logLikeInMixpanel(likeObject.postType, postData.title);
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        })
      } else {

        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        })
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  openCommentModal(data) {
    if (this.loggedInStatus) {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus && this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      }
      else {
        this.nickNameModalService.openNickNameModal();
      }
    }
    else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  populateComments(data) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        data.showComments = !data.showComments;
        this.isActiveID = data.id;
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  openLikeModal(data) {
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  showModal() {
    $("#company-details").modal("show");
    this.companyDetails.initializeModal();
  }

  paginate(event: any) {

    this.dataLimit = event.rows;
    this.skipValue = event.first;
    this.getAllResearchData();
  }

  snapshotPageNavigation(allResearchDat) {
    // let researchDataModel = {
    //   id: allResearchDat.id,
    //   title: allResearchDat.title,
    //   participants: allResearchDat.participants,
    //   ratings: allResearchDat.ratings,
    //   createdAt: allResearchDat.createdAt,
    //   synopsis: allResearchDat.synopsis,
    //   isParticipated: allResearchDat.isParticipated,
    //   surveyId: allResearchDat.survey.id
    // };
    //this.dataService.researchDocumentDataService(researchDataModel);

    this.breadcrumService.setUrl('BC3Label',allResearchDat.title);
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data/${allResearchDat.id}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-snapshot/${allResearchDat.id}`]);
    }
    
  }

  displayShareModal(researchData) {
    this.shareUrl = `${document.location.origin}/#/link?type=research&id=${researchData.id}`;
    $("#share-modal").modal("show");
  }

  featureUnderConstructionNavigation() {
    if (this.loggedInStatus) {
      this.router.navigate([`${this.userRole}/under-construction`]);
    } else {
      this.router.navigate([`under-construction`]);
    }
  }
  closeShareModal() {
    $("#share-modal").modal("hide");
  }

  getHrefUrl(allResearchDat){
  // research document click
  if (this.loggedInStatus && this.userRole === "tech-buyer") {
    return `/${this.userRole}/research-snapshot/${allResearchDat.id}`;
  } else if (this.loggedInStatus && this.userRole === "tech-vendor") {
    return `/${this.userRole}/market-data/${allResearchDat.id}`;
  } else if (this.loggedInStatus && (this.userRole === "tech-analyst"  || this.userRole === "ecosystm-staff")) {
    return `/${this.userRole}/research-snapshot/${allResearchDat.id}`;
  } else if (!this.loggedInStatus) {
    return `/signin`;
  }
  }
  calculateDelay(searchString: Observable<string>) {
    // if(_.isEqual(this.lastSearch, {})) {
    //   this.lastSearch = {
    //     key: searchString,
    //     time: moment().toISOString()
    //   };
    // if(searchString.length > 3) {
    //   this.dataLimit = 9;
    //   this.skipValue = 0;
    //   if (this.paginator) {
    //     this.paginator.first = 0;
    //   }
    //   this.allResearchData = [];
    //   this.getAllResearchData();
    // }
    // }
    return searchString.pipe(debounceTime(400),
    distinctUntilChanged(),
    switchMap(searchst =>  this.getAllResearchData())
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/all-research/all-research.component.ts